/** Match if every query word appears in label, shortLabel, or synonyms. */
export function fuzzyMatchLabel(
  label: string,
  shortLabel: string,
  synonyms: string[],
  query: string
): boolean {
  const q = query.trim().toLowerCase();

  if (!q) {
    return true;
  }

  const haystack = `${label} ${shortLabel} ${synonyms.join(' ')}`.toLowerCase();

  return q.split(/\s+/).every((word) => haystack.includes(word));
}
